import React from "react";
//UI
import { Checkbox, Input, Radio, SearchInput, Select, Textarea } from "../../../ui/inputs/Input";
import { InfoButton } from "../../../ui/buttons/Button";
export default function Usuarios() {
  return (
    <div className="col-8 m-0 p-2 border rounded">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="m-0 fw-bold">Usuarios</h3>
        <a type="button" className="fw-bold text-light fs-6">
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </header>
      <ul class="nav nav-tabs col-12 m-0 my-2 p-0" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link active"
            id="usuario-tab"
            data-bs-toggle="tab"
            data-bs-target="#usuario-tab-pane"
            type="button"
            role="tab"
            aria-controls="usuario-tab-pane"
            aria-selected="true"
          >
            Usuario
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            id="permisos-tab"
            data-bs-toggle="tab"
            data-bs-target="#permisos-tab-pane"
            type="button"
            role="tab"
            aria-controls="permisos-tab-pane"
            aria-selected="false"
          >
            Permisos Aplicación Ingenieria Municipal
          </button>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent" style={{ minHeight: 310 }}>
        <div
          class="tab-pane fade show active"
          id="usuario-tab-pane"
          role="tabpanel"
          aria-labelledby="usuario-tab"
          tabindex="0"
        >
          <div className="col-12 m-0 p-0 d-flex flex-wrap">
            <div className="col-2 m-0 p-0">
              <Input label="Código:" />
            </div>
            <div className="col-3 m-0 p-0 pl-2">
              <Input label="Nombre de Usuario:" />
            </div>
            <div className="col-3 m-0 p-0 d-flex input-group-sm pl-2">
              <Input label="Contraseña:" />
              <InfoButton icon="fa-eye m-0" className="rounded-0" />
            </div>
            <div className="col-4 m-0 p-0 d-flex input-group-sm pl-2">
              <Input label="Confirmar Contraseña:" />
              <InfoButton icon="fa-eye m-0" className="rounded-0" />
            </div>
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none w-auto m-0">Organización</legend>
              <div className="col-3 m-0 p-0 pr-2">
                <SearchInput label="Código:" />
              </div>
              <Input />
            </fieldset>
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos Personales
              </legend>
              <div className="col-12 m-0 p-0">
                <div className="col-3 m-0 mb-2 p-0 pr-2">
                  <SearchInput label="Cedula:" />
                </div>
              </div>
              <div className="col-6 m-0 mb-2 p-0">
                <Input label="Nombres:" />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input label="Apellidos:" />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Textarea label="Dirección:" style={{ height: 70 }} />
              </div>
              <div className="col-3 m-0 mb-2 p-0">
                <Input label="Correo Electrónico:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Telefono:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Celular:" />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label="Fecha de Nacimiento:" type="date" />
              </div>
              <div className="col-3 m-0 mb-2 p-0">
                <Select label="Nacionalidad:"></Select>
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Select label="Sexo:"></Select>
              </div>
            </fieldset>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="permisos-tab-pane"
          role="tabpanel"
          aria-labelledby="permisos-tab"
          tabindex="0"
        >
          <ul
            class="nav nav-tabs col-12 m-0 my-2 p-0"
            id="myTab"
            role="tablist"
          >
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="actualizacion-tab"
                data-bs-toggle="tab"
                data-bs-target="#actualizacion-tab-pane"
                type="button"
                role="tab"
                aria-controls="actualizacion-tab-pane"
                aria-selected="true"
              >
                Actualización
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="registro-tab"
                data-bs-toggle="tab"
                data-bs-target="#registro-tab-pane"
                type="button"
                role="tab"
                aria-controls="registro-tab-pane"
                aria-selected="false"
              >
                Registro
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="reportes-tab"
                data-bs-toggle="tab"
                data-bs-target="#reportes-tab-pane"
                type="button"
                role="tab"
                aria-controls="reportes-tab-pane"
                aria-selected="false"
              >
                Reportes
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="configuracion-tab"
                data-bs-toggle="tab"
                data-bs-target="#configuracion-tab-pane"
                type="button"
                role="tab"
                aria-controls="configuracion-tab-pane"
                aria-selected="false"
              >
                Configuración
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent2">
            <div
              class="tab-pane fade show active"
              id="actualizacion-tab-pane"
              role="tabpanel"
              aria-labelledby="actualizacion-tab"
              tabindex="0"
            >
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <fieldset className="col-6 m-0 mb-2 p-2 d-flex flex-wrap justify-content-between gap-2 border-azul rounded">
                  <legend className="float-none w-auto m-0">Compañias</legend>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Consultar" id = 'consultarCompanias' />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Incluir" id = 'incluirCompanias' />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Editar" id = 'editarCompanias' />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Eliminar" id = 'eliminarCompanias' />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Checkbox label="Todas" id = 'todasCompanias' />
                  </div>
                </fieldset>
                <div className="col-6 m-0 mb-2 p-0 pl-2 mb-2">
                  <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between gap-2 border-azul rounded">
                    <legend className="float-none w-auto m-0">Registro de Obras</legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Consultar" id = 'registroConsultar' />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Incluir" id = 'registroIncluir' />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id = 'registroEditar' />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Eliminar" id = 'registroEliminar' />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id = 'registroTodas' /> 
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="registro-tab-pane"
              role="tabpanel"
              aria-labelledby="registro-tab"
              tabindex="0"
            >
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <div className="col-3 m-0 p-0">
                  <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between gap-2 border-azul rounded">
                    <legend className="float-none w-auto m-0">Asignacion de Obras</legend>
                    <div className="col-auto m-0 p-0">
                      <Radio label = 'Disponible' name = 'asignacionObras' id = 'asignacionObras1' />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio label = 'No Disponible' name = 'asignacionObras' id = 'asignacionObras2' />
                    </div>
                  </fieldset>
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between gap-2 border-azul rounded">
                  <legend className="float-none w-auto m-0">Caratula de Contrato</legend>
                  <div className="col-auto m-0 p-0">
                    <Radio label = 'Disponible' name = 'asignacionObras' id = 'asignacionObras1' />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio label = 'No Disponible' name = 'asignacionObras' id = 'asignacionObras2' />
                  </div>
                </fieldset>
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between gap-2 border-azul rounded">
                    <legend className="float-none w-auto m-0">Cuaderno Obras</legend>
                    <div className="col-auto m-0 p-0">
                      <Radio label = 'Disponible' name = 'asignacionObras' id = 'asignacionObras1' />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio label = 'No Disponible' name = 'asignacionObras' id = 'asignacionObras2' />
                    </div>
                  </fieldset>
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between gap-2 border-azul rounded">
                  <legend className="float-none w-auto m-0">Aprobar Solicitud de Pago</legend>
                  <div className="col-auto m-0 p-0">
                    <Radio label = 'Disponible' name = 'asignacionObras' id = 'asignacionObras1' />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio label = 'No Disponible' name = 'asignacionObras' id = 'asignacionObras2' />
                  </div>
                </fieldset>
                </div>
                <div className="col-3 m-0 p-0">
                  <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between gap-2 border-azul rounded">
                    <legend className="float-none w-auto m-0">Asignacion de Obras</legend>
                    <div className="col-auto m-0 p-0">
                      <Radio label = 'Disponible' name = 'asignacionObras' id = 'asignacionObras1' />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio label = 'No Disponible' name = 'asignacionObras' id = 'asignacionObras2' />
                    </div>
                  </fieldset>
                </div>
                <div className="col-6 m-0 p-0 pl-2">
                  <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between gap-2 border-azul rounded">
                    <legend className="float-none w-auto m-0">Asignacion de Obras</legend>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Consultar" id = 'consultarAsignacion' />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Incluir" id = 'incluirAsignacion' />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Editar" id = 'editarAsignacion' />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Eliminar" id = 'eliminarAsignacion' />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Checkbox label="Todas" id = 'todasAsignacion' />
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="reportes-tab-pane"
              role="tabpanel"
              aria-labelledby="reportes-tab"
              tabindex="0"
            >
              reportes
            </div>
            <div
              class="tab-pane fade"
              id="configuracion-tab-pane"
              role="tabpanel"
              aria-labelledby="configuracion-tab"
              tabindex="0"
            >
              configuracion
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
